/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {FILES_FORM} from '../files-forms.config';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {DamElasticDTO, FileService, PageApiResponse} from 'compob2b-libs';
import {DamCatalogComponent} from '../dam-table/dam-catalog.component'
import {ShareDamItemVersionsComponent} from '../share-dam-item-versions/share-dam-item-versions.component'

@Component({
  selector: 'app-share-dam-list',
  styleUrls: ['./share-dam-list.component.scss'],
  templateUrl: './share-dam-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareDamListComponent extends DamCatalogComponent implements OnInit {

  @Input() h1: string;
  @Input() shareSyncUid: string;

  config: CrudConfig = {
    uri: null,
    columns: FILES_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    title: this.title,
  };

  ngOnInit(): void {
    this.config.uri = '/dam/shared-files/' + this.shareSyncUid;
    if (this.h1) {
      this.title = this.h1;
    }

    super.setConfig(this.config);
    this.configure();

    this.loading = true;
    this.showProductBlocks(localStorage.getItem('damView') || 'list');

    this.route.queryParamMap.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      catchError(err => this.handleError(err)),
      switchMap(_ => this.data = this.filterDataDam()),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  public filterDataDam(): Observable<DamElasticDTO[]> {
    this.loading = true;
    this.cdr.detectChanges();

    this.updatePagerFromUri();

    const params: any = this.route.snapshot.queryParams;
    return this.compoApiService.getWithParams<PageApiResponse<DamElasticDTO[]>>(this.getListURI(), params)
      .pipe(
        take(1),
        tap(response => this.handleResponse(response.data)),
        map(response => response.data?.content),
        tap(_ => this.cdr.detectChanges()),
      );
  }

  elementClickEventHandler(element: DamElasticDTO) {
    this.compoApiService.get<DamElasticDTO>('/dam/shared-item/' + element.syncUid).pipe(take(1)).subscribe(response => {
      this.damElasticDTO = response.data;

      this.windowService.open(ShareDamItemVersionsComponent,
        {
          context: {
            model: this.damElasticDTO
          }
        }
      );
      this.cdr.detectChanges();
    });
  }

  downloadShare() {
    this.loading = true;
    this.fileService.downloadUrl('/dam/shared-download/' + this.shareSyncUid)
      .pipe(take(1))
      .subscribe(response => {
        FileService.saveAs(response, 'download.zip');
        this.loading = false;
      });
  }

}
